var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingImagePlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 41,
    viewBox: "0 0 135 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.08203,
    width: 134,
    height: 39,
    rx: 4.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.136 22.3329C65.784 22.3329 63.867 24.1219 63.867 26.5859C63.867 29.0349 65.784 30.8389 68.136 30.8389C70.489 30.8389 72.406 29.0349 72.406 26.5859C72.405 24.1219 70.488 22.3329 68.136 22.3329ZM68.136 29.1649C66.847 29.1649 65.736 28.1019 65.736 26.5869C65.736 25.0559 66.848 24.0089 68.136 24.0089C69.425 24.0089 70.536 25.0559 70.536 26.5869C70.536 28.1009 69.425 29.1649 68.136 29.1649ZM58.822 22.3329C56.47 22.3329 54.553 24.1219 54.553 26.5859C54.553 29.0349 56.47 30.8389 58.822 30.8389C61.175 30.8389 63.092 29.0349 63.092 26.5859C63.092 24.1219 61.175 22.3329 58.822 22.3329ZM58.822 29.1649C57.533 29.1649 56.422 28.1019 56.422 26.5869C56.422 25.0559 57.534 24.0089 58.822 24.0089C60.111 24.0089 61.222 25.0559 61.222 26.5869C61.223 28.1009 60.111 29.1649 58.822 29.1649ZM47.744 23.6389V25.4429H52.062C51.933 26.4579 51.595 27.1989 51.079 27.7139C50.451 28.3419 49.468 29.0349 47.744 29.0349C45.086 29.0349 43.008 26.8919 43.008 24.2339C43.008 21.5759 45.086 19.4329 47.744 19.4329C49.178 19.4329 50.225 19.9969 50.998 20.7219L52.271 19.4489C51.191 18.4179 49.758 17.6289 47.744 17.6289C44.103 17.6289 41.042 20.5929 41.042 24.2339C41.042 27.8749 44.103 30.8389 47.744 30.8389C49.709 30.8389 51.192 30.1939 52.351 28.9859C53.543 27.7939 53.914 26.1179 53.914 24.7649C53.914 24.3469 53.882 23.9599 53.817 23.6379H47.744V23.6389ZM93.052 25.0399C92.698 24.0899 91.618 22.3329 89.411 22.3329C87.22 22.3329 85.399 24.0569 85.399 26.5859C85.399 28.9699 87.204 30.8389 89.62 30.8389C91.569 30.8389 92.697 29.6469 93.165 28.9539L91.715 27.9869C91.232 28.6959 90.571 29.1629 89.62 29.1629C88.67 29.1629 87.993 28.7279 87.558 27.8739L93.245 25.5219L93.052 25.0399ZM87.252 26.4579C87.204 24.8139 88.525 23.9769 89.476 23.9769C90.217 23.9769 90.845 24.3479 91.055 24.8789L87.252 26.4579ZM82.629 30.5819H84.497V18.0809H82.629V30.5819ZM79.567 23.2839H79.503C79.084 22.7839 78.278 22.3329 77.264 22.3329C75.137 22.3329 73.188 24.2019 73.188 26.6029C73.188 28.9869 75.137 30.8399 77.264 30.8399C78.279 30.8399 79.084 30.3889 79.503 29.8739H79.567V30.4859C79.567 32.1129 78.697 32.9829 77.296 32.9829C76.152 32.9829 75.443 32.1619 75.153 31.4689L73.526 32.1459C73.993 33.2729 75.233 34.6589 77.296 34.6589C79.487 34.6589 81.34 33.3699 81.34 30.2279V22.5919H79.568V23.2839H79.567ZM77.425 29.1649C76.136 29.1649 75.057 28.0849 75.057 26.6029C75.057 25.1039 76.136 24.0089 77.425 24.0089C78.697 24.0089 79.696 25.1039 79.696 26.6029C79.696 28.0849 78.697 29.1649 77.425 29.1649ZM101.806 18.0809H97.335V30.5819H99.2V25.8459H101.805C103.873 25.8459 105.907 24.3489 105.907 21.9639C105.907 19.5789 103.874 18.0809 101.806 18.0809ZM101.854 24.1059H99.2V19.8209H101.854C103.249 19.8209 104.041 20.9759 104.041 21.9639C104.041 22.9319 103.249 24.1059 101.854 24.1059ZM113.386 22.3109C112.035 22.3109 110.636 22.9059 110.057 24.2249L111.713 24.9159C112.067 24.2249 112.727 23.9989 113.418 23.9989C114.383 23.9989 115.364 24.5779 115.38 25.6069V25.7359C115.042 25.5429 114.318 25.2539 113.434 25.2539C111.649 25.2539 109.831 26.2349 109.831 28.0679C109.831 29.7409 111.295 30.8179 112.935 30.8179C114.189 30.8179 114.881 30.2549 115.315 29.5949H115.379V30.5599H117.181V25.7669C117.182 23.5489 115.524 22.3109 113.386 22.3109ZM113.16 29.1619C112.55 29.1619 111.697 28.8559 111.697 28.0999C111.697 27.1349 112.759 26.7649 113.676 26.7649C114.495 26.7649 114.882 26.9419 115.38 27.1829C115.235 28.3419 114.238 29.1619 113.16 29.1619ZM123.743 22.5839L121.604 28.0039H121.54L119.32 22.5839H117.31L120.639 30.1589L118.741 34.3729H120.687L125.818 22.5839H123.743ZM106.937 30.5819H108.802V18.0809H106.937V30.5819Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.418 10.8252C47.418 11.6632 47.1701 12.3302 46.673 12.8282C46.109 13.4202 45.3731 13.7162 44.4691 13.7162C43.6031 13.7162 42.8661 13.4162 42.2611 12.8162C41.6551 12.2152 41.3521 11.4712 41.3521 10.5832C41.3521 9.69422 41.6551 8.95022 42.2611 8.35022C42.8661 7.74922 43.6031 7.44922 44.4691 7.44922C44.8991 7.44922 45.3101 7.53322 45.7001 7.70022C46.0911 7.86822 46.404 8.09122 46.6381 8.37022L46.111 8.89822C45.714 8.42322 45.167 8.18622 44.468 8.18622C43.836 8.18622 43.29 8.40822 42.829 8.85222C42.368 9.29622 42.1381 9.87322 42.1381 10.5822C42.1381 11.2912 42.368 11.8682 42.829 12.3122C43.29 12.7562 43.836 12.9782 44.468 12.9782C45.138 12.9782 45.6971 12.7552 46.1441 12.3082C46.4341 12.0172 46.602 11.6122 46.647 11.0932H44.468V10.3722H47.375C47.405 10.5292 47.418 10.6802 47.418 10.8252Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0281 8.31928H49.2961V10.2213H51.7601V10.9423H49.2961V12.8443H52.0281V13.5823H48.5251V7.58228H52.0281V8.31928Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.279 13.5823H54.508V8.31928H52.832V7.58228H56.955V8.31928H55.279V13.5823Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.938 13.5823V7.58228H60.709V13.5823H59.938Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1281 13.5823H63.3572V8.31928H61.6812V7.58228H65.8042V8.31928H64.1281V13.5823Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6089 12.8073C73.0189 13.4133 72.2859 13.7163 71.4089 13.7163C70.5319 13.7163 69.7989 13.4133 69.2099 12.8073C68.6199 12.2013 68.3259 11.4593 68.3259 10.5823C68.3259 9.70527 68.6199 8.96327 69.2099 8.35727C69.7989 7.75127 70.5319 7.44727 71.4089 7.44727C72.2809 7.44727 73.0129 7.75227 73.6049 8.36127C74.1969 8.97027 74.4929 9.71027 74.4929 10.5823C74.4929 11.4593 74.1979 12.2013 73.6089 12.8073ZM69.7789 12.3043C70.2229 12.7543 70.7659 12.9783 71.4089 12.9783C72.0519 12.9783 72.5959 12.7533 73.0389 12.3043C73.4829 11.8543 73.7059 11.2803 73.7059 10.5823C73.7059 9.88427 73.4829 9.31027 73.0389 8.86027C72.5959 8.41027 72.0519 8.18627 71.4089 8.18627C70.7659 8.18627 70.2229 8.41127 69.7789 8.86027C69.3359 9.31027 69.1129 9.88427 69.1129 10.5823C69.1129 11.2803 69.3359 11.8543 69.7789 12.3043Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5749 13.5823V7.58228H76.513L79.429 12.2493H79.4619L79.429 11.0933V7.58228H80.1999V13.5823H79.3949L76.344 8.68828H76.3109L76.344 9.84427V13.5823H75.5749Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.418 10.8252C47.418 11.6632 47.1701 12.3302 46.673 12.8282C46.109 13.4202 45.3731 13.7162 44.4691 13.7162C43.6031 13.7162 42.8661 13.4162 42.2611 12.8162C41.6551 12.2152 41.3521 11.4712 41.3521 10.5832C41.3521 9.69422 41.6551 8.95022 42.2611 8.35022C42.8661 7.74922 43.6031 7.44922 44.4691 7.44922C44.8991 7.44922 45.3101 7.53322 45.7001 7.70022C46.0911 7.86822 46.404 8.09122 46.6381 8.37022L46.111 8.89822C45.714 8.42322 45.167 8.18622 44.468 8.18622C43.836 8.18622 43.29 8.40822 42.829 8.85222C42.368 9.29622 42.1381 9.87322 42.1381 10.5822C42.1381 11.2912 42.368 11.8682 42.829 12.3122C43.29 12.7562 43.836 12.9782 44.468 12.9782C45.138 12.9782 45.6971 12.7552 46.1441 12.3082C46.4341 12.0172 46.602 11.6122 46.647 11.0932H44.468V10.3722H47.375C47.405 10.5292 47.418 10.6802 47.418 10.8252Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0281 8.31928H49.2961V10.2213H51.7601V10.9423H49.2961V12.8443H52.0281V13.5823H48.5251V7.58228H52.0281V8.31928Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.279 13.5823H54.508V8.31928H52.832V7.58228H56.955V8.31928H55.279V13.5823Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.938 13.5823V7.58228H60.709V13.5823H59.938Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1281 13.5823H63.3572V8.31928H61.6812V7.58228H65.8042V8.31928H64.1281V13.5823Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6089 12.8073C73.0189 13.4133 72.2859 13.7163 71.4089 13.7163C70.5319 13.7163 69.7989 13.4133 69.2099 12.8073C68.6199 12.2013 68.3259 11.4593 68.3259 10.5823C68.3259 9.70527 68.6199 8.96327 69.2099 8.35727C69.7989 7.75127 70.5319 7.44727 71.4089 7.44727C72.2809 7.44727 73.0129 7.75227 73.6049 8.36127C74.1969 8.97027 74.4929 9.71027 74.4929 10.5823C74.4929 11.4593 74.1979 12.2013 73.6089 12.8073ZM69.7789 12.3043C70.2229 12.7543 70.7659 12.9783 71.4089 12.9783C72.0519 12.9783 72.5959 12.7533 73.0389 12.3043C73.4829 11.8543 73.7059 11.2803 73.7059 10.5823C73.7059 9.88427 73.4829 9.31027 73.0389 8.86027C72.5959 8.41027 72.0519 8.18627 71.4089 8.18627C70.7659 8.18627 70.2229 8.41127 69.7789 8.86027C69.3359 9.31027 69.1129 9.88427 69.1129 10.5823C69.1129 11.2803 69.3359 11.8543 69.7789 12.3043Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5749 13.5823V7.58228H76.513L79.429 12.2493H79.4619L79.429 11.0933V7.58228H80.1999V13.5823H79.3949L76.344 8.68828H76.3109L76.344 9.84427V13.5823H75.5749Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1355_16620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.436 8.11988C10.145 8.42788 9.97302 8.90588 9.97302 9.52488V31.6409C9.97302 32.2609 10.145 32.7379 10.436 33.0459L10.51 33.1179L22.899 20.7289V20.5829V20.4369L10.51 8.04688L10.436 8.11988Z",
    fill: "url(#paint0_linear_1355_16620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.028 24.8596L22.899 20.7286V20.5826V20.4366L27.029 16.3066L27.122 16.3596L32.015 19.1396C33.412 19.9336 33.412 21.2326 32.015 22.0276L27.122 24.8076L27.028 24.8596Z",
    fill: "url(#paint1_linear_1355_16620)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1355_16620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.122 24.806L22.898 20.582L10.436 33.045C10.896 33.533 11.657 33.593 12.514 33.107L27.122 24.806Z",
    fill: "url(#paint2_linear_1355_16620)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.122 16.3587L12.514 8.05873C11.657 7.57173 10.896 7.63273 10.436 8.12073L22.899 20.5837L27.122 16.3587Z",
    fill: "url(#paint3_linear_1355_16620)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.08203,
    width: 134,
    height: 39,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1355_16620",
    x: 9.97302,
    y: 7.72266,
    width: 23.0898,
    height: 25.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_16620"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1355_16620",
    result: "effect2_innerShadow_1355_16620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1355_16620",
    x: 10.436,
    y: 20.582,
    width: 16.686,
    height: 12.8613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_16620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1355_16620",
    x1: 21.8008,
    y1: 9.29087,
    x2: 5.01882,
    y2: 26.0729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1355_16620",
    x1: 33.8335,
    y1: 20.5826,
    x2: 9.63765,
    y2: 20.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1355_16620",
    x1: 24.8281,
    y1: 22.8759,
    x2: 2.06964,
    y2: 45.6344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1355_16620",
    x1: 7.29743,
    y1: 0.758532,
    x2: 17.4597,
    y2: 10.9208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingImagePlayStore);
export default __webpack_public_path__ + "static/media/landingImagePlayStore.2010149671c7caedbd8c2be43809e9c9.svg";
export { ForwardRef as ReactComponent };